import {_} from 'lodash';
import * as ko from "knockout";
import {template as tpl, viewModel as UserSearch} from "./search";
import {IObjectData} from "../../index";
import {FilterType, IObjectSearchParams} from "../object/search";
import {getObjectFromRouteData} from "../../util/request";

export let template: string = tpl

export class viewModel extends UserSearch {

    constructor(params: IObjectSearchParams) {
        super(_.defaults(params, {autoRequest: false}));
        this.filterOptions.department_secondaryPositions(true)

        this.init()
    }

    protected override initMain(): Promise<any> {
        return this.__requestRouteData!.request()
            .then((data: IObjectData[]) => {
                const department = getObjectFromRouteData(data);
                this.filterOptions.department(department);
            })
    }

    protected override isInitialDepartment: (o: any) => boolean = (t: string[]) => {
        return t[0] == String(this.__id ?? '')
    }

    protected override setFilterObservables(observables?: any) {
        super.setFilterObservables({department: ko.observable(null)});
    }

    override isFilterEnabled(filterType: FilterType): boolean {
        if (filterType == FilterType.Department) {
            return false;
        }
        return super.isFilterEnabled(filterType);
    }

    override onResetClick() {
        super.onResetClick()
        this.filterOptions.department_secondaryPositions(true)
    }
}
